import {
  SET_2FA_REQUIRED,
  SET_2FA_SETUP_REQUIRED,
  SET_2FA_REVERIFICATION_REQUIRED,
  CLEAR_2FA_STATE,
  LOGOUT,
} from '~/redux/actions/action-types';

const initialState = {
  requires2FA: false,
  requires2FASetup: false,
  requiresReverification: false,
  tempToken: null,
  maskedEmail: null,
};

const twoFactorReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_2FA_REQUIRED:
      return {
        ...state,
        requires2FA: true,
        tempToken: payload.tempToken,
        maskedEmail: payload.email,
      };
    case SET_2FA_SETUP_REQUIRED:
      return {
        ...state,
        requires2FASetup: true,
        tempToken: payload.tempToken,
        maskedEmail: payload.email,
      };
    case SET_2FA_REVERIFICATION_REQUIRED:
      return {
        ...state,
        requiresReverification: true,
        maskedEmail: payload.email,
      };
    case CLEAR_2FA_STATE:
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { twoFactorReducer };
